import React from "react";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import { MdWarningAmber } from "react-icons/md";
import { useNavigate } from "react-router-dom";

function PageNotFound(props) {
  const navigate = useNavigate();
  return (
    <Container className="mainContent text-center">
      <MdWarningAmber size="50px" />
      <h1 className="my-3">Page Not Found</h1>
      <p>
        The page you're looking for doesn't exist or another error occured.{" "}
      </p>
      <Button onClick={() => navigate(-1)}>Go back</Button>
    </Container>
  );
}

export default PageNotFound;
